import { DndContext } from '@dnd-kit/core';
import cx from 'classnames';
import ClozeParagraphReadOnly from '../ClozeParagraphReadOnly';
import TemplateResponseFieldRenderer from '../TemplateResponseFieldRenderer';
import {
  DraggableWordBank,
  Dropzone,
  DraggableWord,
  useWordBank,
  useClozeDragAndDrop,
} from '../DragAndDrop';
import style from './style.scss';
/* eslint-disable react/prop-types */ // TODO: add props

export const ClozeParagraphDragAndDrop = ({
  blockData: { text, options },
  blockResponse: { response_values: responseValues = [] } = {},
  onResponseChange,
  readOnly,
}) => {
  const { remainingWords } = useWordBank(options, responseValues);
  const recordMovement = useClozeDragAndDrop(
    remainingWords,
    responseValues,
    onResponseChange
  );

  const handleDragEnd = (event) => {
    if (!event.over) {
      return;
    }

    recordMovement(
      event.active.id,
      event.over.id,
      event.active.data.current?.responseFieldIndex
    );
  };

  if (readOnly) {
    return (
      <ClozeParagraphReadOnly text={text} responseValues={responseValues} />
    );
  }

  return (
    <DndContext onDragEnd={handleDragEnd}>
      <DraggableWordBank words={remainingWords} disabled={readOnly} />
      <p>
        <TemplateResponseFieldRenderer
          text={text}
          renderResponseField={(responseFieldIndex) => {
            const droppedOption = responseValues[responseFieldIndex];
            const dropzoneKey = `dropzone_${responseFieldIndex}`;
            const droppedKey = `dropped_${responseFieldIndex}`;
            return (
              <Dropzone
                id={dropzoneKey}
                key={dropzoneKey}
                className={cx(style.responseField, {
                  [style.wordDropped]: !!droppedOption,
                })}
                draggableOverClassName={style.responseFieldDraggableOver}
              >
                {droppedOption ? (
                  <DraggableWord
                    id={droppedKey}
                    data={{
                      responseFieldIndex,
                    }}
                  >
                    {droppedOption}
                  </DraggableWord>
                ) : (
                  <>&nbsp;</>
                )}
              </Dropzone>
            );
          }}
        />
      </p>
    </DndContext>
  );
};
